import { ScmIntegrations } from '@backstage/integration';
import { createApiRef } from '@backstage/core-plugin-api';

class ScmIntegrationsApi {
  /**
   * Instantiates an {@link @backstage/integration#ScmIntegrationRegistry}.
   *
   * @param config - The root of the config hierarchy.
   */
  static fromConfig(config) {
    return ScmIntegrations.fromConfig(config);
  }
}
const scmIntegrationsApiRef = createApiRef({
  id: "integration.scmintegrations"
});

export { ScmIntegrationsApi, scmIntegrationsApiRef };
//# sourceMappingURL=ScmIntegrationsApi.esm.js.map
